export default "__VITE_ASSET__46915046__"